import React from 'react';
import {
  LayoutDashboard, BarChart3, FileText, Link2, History, ClipboardList,
  LogOut, Sun, Moon, ChevronLeft, ChevronRight, Building2, Settings
} from 'lucide-react';

const NAV_ITEMS = [
  { key: 'dashboard', label: 'Visão Geral', icon: LayoutDashboard },
  { key: 'charts', label: 'Gráficos', icon: BarChart3 },
  { key: 'responses', label: 'Respostas', icon: ClipboardList },
  { key: 'standard-report', label: 'Relatório', icon: FileText },
  { key: 'generator', label: 'Gerar Links', icon: Link2 },
  { key: 'round-history', label: 'Histórico', icon: History },
  { key: 'sectors', label: 'Setores', icon: Building2 },
  { key: 'settings', label: 'Configurações', icon: Settings },
];

export const Sidebar = ({ activeTab, onTabChange, isDarkMode, toggleTheme, onLogout, collapsed, onToggleCollapse }) => {
  return (
    <aside className={`fixed left-0 top-0 h-screen z-30 flex flex-col transition-all duration-200 border-r ${
      collapsed ? 'w-16' : 'w-56'
    } ${isDarkMode ? 'bg-zinc-900 border-zinc-800' : 'bg-white border-zinc-200'}`}
    data-testid="admin-sidebar"
    >
      {/* Logo */}
      <div className={`flex items-center h-14 px-4 border-b ${isDarkMode ? 'border-zinc-800' : 'border-zinc-200'}`}>
        <div className="w-8 h-8 bg-demoraes-green rounded-md flex items-center justify-center flex-shrink-0">
          <span className="text-white font-black text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>D</span>
        </div>
        {!collapsed && (
          <span className={`ml-3 font-bold text-sm tracking-tight truncate ${isDarkMode ? 'text-zinc-100' : 'text-zinc-900'}`}
            style={{ fontFamily: 'Manrope, sans-serif' }}>
            DEMoraes
          </span>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-3 px-2 space-y-0.5 overflow-y-auto">
        {NAV_ITEMS.map(item => {
          const Icon = item.icon;
          const isActive = activeTab === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onTabChange(item.key)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-demoraes-green/10 text-demoraes-green'
                  : isDarkMode
                    ? 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800'
                    : 'text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100'
              }`}
              title={collapsed ? item.label : undefined}
              data-testid={`nav-${item.key}`}
            >
              <Icon size={18} className="flex-shrink-0" />
              {!collapsed && <span className="truncate">{item.label}</span>}
            </button>
          );
        })}
      </nav>

      {/* Footer actions */}
      <div className={`px-2 py-3 border-t space-y-1 ${isDarkMode ? 'border-zinc-800' : 'border-zinc-200'}`}>
        <button
          onClick={toggleTheme}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
            isDarkMode ? 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800' : 'text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100'
          }`}
          title={isDarkMode ? 'Modo Claro' : 'Modo Escuro'}
          data-testid="sidebar-theme-toggle"
        >
          {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
          {!collapsed && <span>{isDarkMode ? 'Modo Claro' : 'Modo Escuro'}</span>}
        </button>

        <button
          onClick={onToggleCollapse}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
            isDarkMode ? 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800' : 'text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100'
          }`}
          data-testid="sidebar-collapse-toggle"
        >
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
          {!collapsed && <span>Recolher</span>}
        </button>

        <button
          onClick={onLogout}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors text-red-500 hover:bg-red-50 ${
            isDarkMode ? 'hover:bg-red-950/30' : ''
          }`}
          data-testid="sidebar-logout"
        >
          <LogOut size={18} />
          {!collapsed && <span>Sair</span>}
        </button>
      </div>
    </aside>
  );
};
